(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jl-client-case"] && !Shopify.designMode) return;
  try {
    
/* Use Vimeo's actual video proportions for optional portrait-frame fills.
   The CSS square fallback also works if Vimeo metadata is unavailable. */
(function(){
  function bindPortraitFills(root){
    if(!window.Vimeo||!window.Vimeo.Player)return;
    (root||document).querySelectorAll('.jl-case .jl-case-video-fill iframe').forEach(function(frame){
      if(frame.dataset.jlFillBound)return;
      frame.dataset.jlFillBound='1';
      var stage=frame.closest('.jl-case-video-fill');
      if(!stage)return;
      var player;
      try{player=new window.Vimeo.Player(frame)}catch(e){return}
      Promise.all([player.getVideoWidth(),player.getVideoHeight()]).then(function(dimensions){
        var vw=Number(dimensions[0]),vh=Number(dimensions[1]);
        if(!(vw>0&&vh>0))return;
        var ratio=vw/vh;
        function fit(){
          var w=stage.clientWidth,h=stage.clientHeight;
          if(!(w>0&&h>0))return;
          var width=Math.max(w,h*ratio),height=Math.max(h,w/ratio);
          frame.style.width=Math.ceil(width)+'px';
          frame.style.height=Math.ceil(height)+'px';
          frame.style.top='50%';
          frame.style.left='50%';
          frame.style.transform='translate(-50%,-50%)';
        }
        fit();
        if('ResizeObserver'in window){
          new ResizeObserver(fit).observe(stage);
        }else{
          window.addEventListener('resize',fit,{passive:true});
        }
      }).catch(function(){/* Preserve square-fit fallback. */});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){bindPortraitFills(document)});
  else bindPortraitFills(document);
  window.addEventListener('load',function(){bindPortraitFills(document)});
  document.addEventListener('shopify:section:load',function(event){bindPortraitFills(event.target)});
})();

/* Fit designated carousel videos to their actual source ratio, never crop. */
(function(){
  function initNativeMedia(root){
    if(!window.Vimeo||!window.Vimeo.Player)return;
    (root||document).querySelectorAll('.jl-case .jl-case-video-natural iframe').forEach(function(frame){
      if(frame.dataset.jlNaturalRatioBound)return;
      frame.dataset.jlNaturalRatioBound='1';
      var stage=frame.closest('.jl-case-video-natural');
      if(!stage)return;
      var player;
      try{player=new window.Vimeo.Player(frame)}catch(e){return}
      Promise.all([player.getVideoWidth(),player.getVideoHeight()]).then(function(dimensions){
        var vw=Number(dimensions[0]),vh=Number(dimensions[1]);
        if(!(vw>0&&vh>0))return;
        var ratio=vw/vh;
        var card=stage.closest('.jl-case-native-card');
        var track=card&&card.closest('.jl-case-carousel-track');
        var portrait=track&&track.querySelector('.jl-case-carousel-card:not(.jl-case-native-card) .jl-case-carousel-media');
        function sizeNaturalCard(){
          if(!card||!portrait)return;
          var portraitHeight=portrait.getBoundingClientRect().height;
          if(!(portraitHeight>0))return;
          card.style.flexBasis=Math.ceil(portraitHeight*ratio)+'px';
          stage.style.aspectRatio=vw+' / '+vh;
        }
        sizeNaturalCard();
        if('ResizeObserver' in window && portrait){
          var observer=new ResizeObserver(sizeNaturalCard);
          observer.observe(portrait);
        }else{
          window.addEventListener('resize',sizeNaturalCard,{passive:true});
        }
      }).catch(function(){/* Retain square fallback when metadata is unavailable. */});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initNativeMedia(document)});
  else initNativeMedia(document);
  window.addEventListener('load',function(){initNativeMedia(document)});
  document.addEventListener('shopify:section:load',function(event){initNativeMedia(event.target)});
})();

document.addEventListener('click', function(event) {
  const arrow = event.target.closest('.jl-case-carousel-arrow');
  if (!arrow) return;
  const carousel = arrow.closest('.jl-case-extras');
  const track = carousel && carousel.querySelector('.jl-case-carousel-track');
  const card = track && track.querySelector('.jl-case-carousel-card');
  if (!track || !card) return;
  const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
  const distance = card.getBoundingClientRect().width + gap;
  const direction = Number(arrow.getAttribute('data-jl-scroll')) || 1;
  track.scrollBy({left:distance * direction,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jl-portfolio"] && !Shopify.designMode) return;
  try {
    
/* Match the Vimeo player to its actual dimensions instead of assuming 16:9.
   Keep a contained player for extreme portrait/landscape mismatches so
   important content is not severely cropped in the homepage card. */
(function(){
  function startHeroVideoSizing(root){
    if(!window.Vimeo||!window.Vimeo.Player)return;
    (root||document).querySelectorAll('.jl-site .jl-vimeo-identity-iframe').forEach(function(frame){
      if(frame.dataset.jlHeroSizingBound)return;
      frame.dataset.jlHeroSizingBound='1';
      var stage=frame.closest('.jl-vimeo-identity');
      if(!stage)return;
      var player;
      try{player=new window.Vimeo.Player(frame);}catch(e){return;}
      Promise.all([player.getVideoWidth(),player.getVideoHeight()]).then(function(dimensions){
        var videoWidth=Number(dimensions[0]),videoHeight=Number(dimensions[1]);
        if(!(videoWidth>0&&videoHeight>0))return;
        var videoRatio=videoWidth/videoHeight;
        function sizeVideo(){
          /* Match the frame's aspect ratio to the video itself. Tall clips
             can grow vertically while remaining inside a sensible height. */
          var isNarrow=window.innerWidth<=760;
          var maximumHeight=isNarrow?700:Math.min(930,Math.max(700,window.innerHeight*1.01));
          stage.style.minHeight='0';
          stage.style.maxHeight='none';
          var scale=1;
          stage.style.width=(scale*100)+'%';
          stage.style.maxWidth=Math.round(maximumHeight*videoRatio*scale)+'px';
          stage.style.height='auto';
          stage.style.aspectRatio=videoWidth+' / '+videoHeight;
          frame.style.inset='0';
          frame.style.top='0';
          frame.style.left='0';
          frame.style.width='100%';
          frame.style.height='100%';
          frame.style.transform='none';
        }
        sizeVideo();
        window.addEventListener('resize',sizeVideo,{passive:true});
      }).catch(function(){
        /* Keep the original video frame if Vimeo metadata is unavailable. */
      });
    });
  }
  function initialize(){startHeroVideoSizing(document);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);
  else initialize();
  window.addEventListener('load',initialize);
  document.addEventListener('shopify:section:load',initialize);
})();
(function(){
  function positionLogoStrip(root){
    var windows=(root||document).querySelectorAll('.jl-site .jl-logo-window');
    windows.forEach(function(win){
      var track=win.querySelector('.jl-logo-track');
      var lead=win.querySelector('.jl-logo-reel [data-jl-logo="wingstop"]');
      if(!track||!lead) return;
      var itemCenter=lead.offsetLeft+(lead.offsetWidth/2);
      var startX=(win.clientWidth/2)-itemCenter;
      if(Number.isFinite(startX))track.style.setProperty('--jl-logo-start-x',startX.toFixed(1)+'px');
    });
  }
  function run(){window.requestAnimationFrame(function(){positionLogoStrip(document);});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);
  else run();
  window.addEventListener('resize',run,{passive:true});
  document.addEventListener('shopify:section:load',run);
})();




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jl-service-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initLiveRatios(root){
    if(!window.Vimeo||!window.Vimeo.Player)return;
    (root||document).querySelectorAll('.jl-sp-live-page .jl-sp-motion-scroll .jl-sp-match-height iframe').forEach(function(frame){
      if(frame.dataset.jlRatioBound)return;
      frame.dataset.jlRatioBound='1';
      var card=frame.closest('.jl-sp-match-height');
      var media=card&&card.querySelector('.jl-sp-media');
      var stage=card&&card.querySelector('.jl-sp-video-stage');
      var track=card&&card.closest('.jl-sp-projects');
      if(!card||!media||!stage||!track)return;
      var player;
      try{player=new window.Vimeo.Player(frame)}catch(e){return}
      Promise.all([player.getVideoWidth(),player.getVideoHeight()]).then(function(dimensions){
        var videoWidth=Number(dimensions[0]),videoHeight=Number(dimensions[1]);
        if(!(videoWidth>0&&videoHeight>0))return;
        var ratio=videoWidth/videoHeight;
        media.style.aspectRatio=videoWidth+' / '+videoHeight;
        stage.style.aspectRatio=videoWidth+' / '+videoHeight;
        function sizeCard(){
          var width=track.clientWidth;
          if(!(width>0))return;
          if(window.innerWidth<=600){
            card.style.flexBasis='82%';
            return;
          }
          var computed=window.getComputedStyle(track);
          var gap=parseFloat(computed.columnGap||computed.gap)||0;
          var portraitWidth;
          if(window.innerWidth<=850)portraitWidth=Math.min(300,Math.max(210,window.innerWidth*.43));
          else if(window.innerWidth>=1600)portraitWidth=(width-3*gap)/4;
          else portraitWidth=(width-2*gap)/3;
          card.style.flexBasis=Math.ceil(portraitWidth*16/9*ratio)+'px';
        }
        sizeCard();
        if('ResizeObserver'in window){
          new ResizeObserver(sizeCard).observe(track);
        }else{
          window.addEventListener('resize',sizeCard,{passive:true});
        }
      }).catch(function(){/* The layout keeps a 16:9 fallback. */});
    });
  }
  function startLiveRatios(){initLiveRatios(document)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',startLiveRatios);
  else startLiveRatios();
  window.addEventListener('load',startLiveRatios);
  document.addEventListener('shopify:section:load',function(e){initLiveRatios(e.target)});
  document.addEventListener('click',function(event){
    var control=event.target.closest('button[data-jl-sp-scroll]');
    if(!control)return;
    var gallery=control.closest('.jl-sp-gallery-only .jl-sp-group, .jl-sp-immersive-page .jl-sp-motion-scroll, .jl-sp-live-page .jl-sp-motion-scroll');
    if(!gallery)return;
    var track=gallery.querySelector('.jl-sp-projects');
    var card=track&&track.querySelector('.jl-sp-project');
    if(!track||!card)return;
    var style=window.getComputedStyle(track);
    var gap=parseFloat(style.columnGap||style.gap)||0;
    var direction=Number(control.getAttribute('data-jl-sp-scroll'))||0;
    var reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollBy({left:direction*(card.getBoundingClientRect().width+gap),behavior:reduceMotion?'auto':'smooth'});
  });
})();

  } catch(e) { console.error(e); }
})();
})();
